var render = function render(){var _vm=this,_c=_vm._self._c;return _c('autocomplete-multiselect',_vm._g(_vm._b({attrs:{"multiple":false}},'autocomplete-multiselect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }